<template>
  <div>
    <h1>Lista da Estrutura em Áreas</h1>
    <b-card>
      <div class="d-flex mb-2">
        <div class="w-75 mr-auto">
          <b-input-group size="sm">
            <b-input-group-prepend v-show="termo_pesquisa">
              <b-button @click="clearSearch" variant="exitos">
                <b-icon icon="x-lg" arial-hidden="true"></b-icon>
              </b-button>
            </b-input-group-prepend>
            <b-form-input
              v-model="termo_pesquisa"
              v-on:keyup.enter="searchTerm"
              placeholder="Pesquisar"
              class="px-2"
              :class="!termo_pesquisa ? 'force-border-start' : ''"
            ></b-form-input>
            <b-input-group-append>
              <b-button @click="searchTerm" variant="exitos">
                <b-icon icon="search"></b-icon>&nbsp; Buscar
              </b-button>
            </b-input-group-append>
          </b-input-group>
        </div>
        <div>
          <b-button size="sm" variant="success" :to="{ name: 'areas_list' }">
            <font-awesome-icon icon="table" />
            Ver tabela
          </b-button>

          <b-button
            size="sm"
            variant="exitos"
            :to="{ name: 'areas_create' }"
            v-if="$can('area:create')"
          >
            <font-awesome-icon icon="plus" />
            Novo
          </b-button>
        </div>
      </div>

      <div class="areas-arvore" v-if="arvore && arvore.length > 0">
        <arvore-item
          v-for="(area, key) in arvore_filtered"
          :key="'item_tree__wrap_' + key"
          :area="area"
        />
      </div>
      <div class="areas-arvore" v-else>
        <p class="text-center">
          Não há resultados para "<b>{{ termo_pesquisa }}</b
          >"
        </p>
      </div>
    </b-card>
  </div>
</template>

<script>
import { mapActions } from "vuex";
import ArvoreItem from "../Components/ArvoreItem.vue";
import { isEmpty, isArr } from "@/helpers/functions/primitives";
import { slugify } from "@/helpers/functions/slugify";

export default {
  components: { ArvoreItem },
  data: () => ({
    arvore: [],
    termo_pesquisa: "",
  }),
  computed: {
    arvore_filtered() {
      let arvore = this.arvore;

      const filterItemTree = (item, term) => {
        const nome = slugify(item.nome);
        let isValidItem = false;

        const sourceItem = Object.assign({}, item, {
          children: [],
        });

        if (isArr(item.children) && !isEmpty(item.children)) {
          for (const itemChild of item.children) {
            const childNodeTree = filterItemTree(itemChild, term);

            if (childNodeTree) {
              sourceItem.children.push(childNodeTree);
              isValidItem = true;
            }
          }
        }

        if (nome.indexOf(term) >= 0) {
          isValidItem = nome.indexOf(term) >= 0;
        }

        if (isValidItem) return sourceItem;
      };

      if (this.termo_pesquisa) {
        arvore = [];
        const term = slugify(this.termo_pesquisa);
        for (const item of this.arvore) {
          const itenIn = filterItemTree(item, term);

          if (itenIn) {
            arvore.push(itenIn);
          }
        }
      }

      return arvore;
    },
  },
  methods: {
    ...mapActions("areas", ["ActionArvore"]),
    async loadData() {
      try {
        this.arvore = await this.ActionArvore();
        this.arvore = this.arvore.filter((tree) => Boolean(tree.status));
      } catch (error) {
        this.$notifications.addNotification({
          message: "Erro ao carregar estrutura da árvore",
          icon: "exclamation-triangle",
          type: "danger",
        });
      }
    },
    purgeTerm(term = "") {
      return slugify(term);
    },
    async searchTerm() {
      // const formatedTerm = this.purgeTerm(this.termo_pesquisa);
      // if (!this.termo_pesquisa) {
      //   return;
      // }
      // if (!formatedTerm.toLowerCase().includes(this.$route.query.q)) {
      //   this.$router.push({
      //     query: {
      //       q: formatedTerm.toLowerCase(),
      //     },
      //   });
      // }
    },
    clearSearch() {
      if (!this.termo_pesquisa) {
        return;
      }
      this.termo_pesquisa = "";
      this.loadData();
      if (!this.$route.query.q) {
        return;
      }
      this.$router.push({
        query: {},
      });
    },
  },
  mounted() {
    this.loadData();
  },
};
</script>

<style>
.force-border-start {
  border-left: 1px solid #cad1d7 !important;
  border-top-left-radius: 0.25rem !important;
  border-bottom-left-radius: 0.25rem !important;
}
</style>
